<template>
  <div class="loading">
    <loader-component :with_text="true" :text="text" text_class="text-white" />
  </div>
</template>

<script>
import loader_component from "@/views/components/loader.vue";
export default {
  name: "FloatingLoader",
  props: {
    text: {
      type: String,
      default: function () {
        return "Loading...";
      },
    },
  },
  components: {
    "loader-component": loader_component,
  },
};
</script>

<style scoped>
.loading {
  position: fixed;
  z-index: 9999;
  height: 100px;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(rgba(20, 20, 20, 0.1), rgba(0, 0, 0, 0.1));
  background: -webkit-radial-gradient(
    rgba(20, 20, 20, 0.5),
    rgba(0, 0, 0, 0.5)
  );
}
</style>